import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./CommonJquery/ScrollToTop";
import { Toaster } from "react-hot-toast";
import Login from "./Components/Pages/Login";
import ContactsUsList from "./Components/Pages/ContactsUslist";
import Blog from "./Components/Pages/Blog";
import AddBlog from "./Components/Pages/AddBlog";
import CatagoryBlog from "./Components/Pages/CatagoryBlog";
import AllUsers from "./Components/Pages/AllUsers";

import AllProducts from "./Components/Pages/AllProducts"
import AddProducts from "./Components/Pages/AddProducts";
import Collection from "./Components/Pages/Collection"
import PodRequest from "./Components/Pages/PodRequest";
import AddCollection from "./Components/Pages/AddCollection";
import Orders from "./Components/Pages/Orders"
import CreateOrder from "./Components/Pages/CreateOrder";
import OrderDetails from "./Components/Pages/OrderDetails";
import Analytics from "./Components/Pages/Analytics";
import AbandoneOrders from "./Components/Pages/AbandoneOrders";
import AllBookings from "./Components/Pages/AllBookings";
import ScanPass from "./Components/Pages/ScanPass";
import { useEffect } from "react";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        {/* <RoutingLogic />  */}
         {/* ✅ ONLY THIS */}
         <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              fontSize: "14px",
            },
          }}
        />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/bookings" element={<AllBookings />} />
          <Route path="/scanpass" element={<ScanPass />} />
          <Route path="/contacts" element={<ContactsUsList />} />
          <Route path="/blog_categories" element={<CatagoryBlog />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/all-users" element={<AllUsers />} />
          <Route path="/allproducts" element={<AllProducts />} />
          <Route path="/addproducts" element={<AddProducts />} />
          <Route path="/editproduct/:id" element={<AddProducts />} />
          <Route path="/product/:id" element={<AddProducts />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/add-collection" element={<AddCollection />} />
          <Route path="/edit_collection/:id" element={<AddCollection />} />

          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:id" element={<OrderDetails />} />
          <Route path="/create-order" element={<CreateOrder />} />
          <Route path="/abandoneorders" element={<AbandoneOrders />} />
          <Route path="/Pod" element={<PodRequest />} />
          <Route path="/add_blog" element={<AddBlog />} />
          <Route path="/edit_blog/:id" element={<AddBlog />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

// function RoutingLogic() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const adminAuth = localStorage.getItem("lazyx_admin_token");
//     const isLoggedIn = !!adminAuth;
//     const currentPath = location.pathname;

//     if (!isLoggedIn) {
//       if (currentPath !== "/") {
//         navigate("/", { replace: true });
//       }
//     } else {
//       if (currentPath === "/" || currentPath === "") {
//         navigate("/analytics", { replace: true });
//       }
//     }
//   }, [location.pathname, navigate]);

//   return null;
// }


export default App;